import { render, staticRenderFns } from "./TelaComVideo.vue?vue&type=template&id=ff85d4a8&style=true&"
import script from "./TelaComVideo.vue?vue&type=script&lang=js&"
export * from "./TelaComVideo.vue?vue&type=script&lang=js&"
import style0 from "./TelaComVideo.vue?vue&type=style&index=0&id=ff85d4a8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports